var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2719",
    "data-name": "Group 2719",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.018,
    height: 16.714,
    viewBox: "0 0 15.018 16.714",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    d: "M17.446,20.683a.721.721,0,0,1-.721-.721v-1.7a2.676,2.676,0,0,0-2.673-2.673H7.265a2.676,2.676,0,0,0-2.673,2.673v1.7a.721.721,0,1,1-1.442,0v-1.7A4.12,4.12,0,0,1,7.265,14.15h6.788a4.12,4.12,0,0,1,4.115,4.115v1.7A.721.721,0,0,1,17.446,20.683Z",
    transform: "translate(-3.15 -3.969)",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    d: "M3.265-.85A4.115,4.115,0,1,1-.85,3.265,4.12,4.12,0,0,1,3.265-.85Zm0,6.788A2.673,2.673,0,1,0,.592,3.265,2.676,2.676,0,0,0,3.265,5.938Z",
    transform: "translate(4.244 0.85)",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdd);
export default __webpack_public_path__ + "static/media/userAdd.da49fd91856612eab8e7d9c6fa0196c9.svg";
export { ForwardRef as ReactComponent };